import { LoginOutput, MePassengerOutput } from '@allocab/allocab-commons-shared-types';
import {
  Draft,
  Tweaks,
} from '@allocab/allocab-passenger-shared-types/lib/src/booking/input/init-booking-session.input';
import { encodeURI } from 'js-base64';

import { Spinner } from './Spinner';
import { useFetchAccount } from '../hooks/useFetchAccount';
import { initialLocale } from '../services/translation/translation';
export type Product = 'ALLOCAB' | 'HOTELS';
export type Target = 'development' | 'staging' | 'production';
export type BookerProps = {
  product: Product;
  target: Target;
  tokens: LoginOutput | null | undefined;
  user: MePassengerOutput | null | undefined;
  invoiceMention: string | null;
};

export function Booker({ product, target, tokens, user, invoiceMention }: BookerProps) {
  const { data: account } = useFetchAccount();

  if (!tokens || !user) {
    return (
      <div className="p-10">
        <Spinner />
      </div>
    );
  }
  const qs = encodeURI(JSON.stringify({ tokens, user, product }));
  const tweaks: Tweaks = {
    paymentCardDenied: true,
    ...(invoiceMention ? { invoiceMention: invoiceMention.toUpperCase() } : {}),
  };

  const draft: Draft = {
    delay: 'LATER',
    addresses: [{ formattedAddress: account?.address.formatted ? account.address.formatted : '' }],
    admin: user.admin ? user.admin : false,
    locale: initialLocale,
  };

  let src;
  if (product === 'ALLOCAB') {
    if (target === 'production') {
      src = 'https://www.allocab.com/app/booker/hotel';
    } else {
      src = 'https://dv.allocab.com/app/booker/hotel';
    }
  } else if (product === 'HOTELS') {
    if (target === 'production') {
      src = 'https://hotels.allocab.com/booker/hotel';
    } else {
      src = 'https://hotels-dev.allocab.com/booker/hotel';
    }
  }
  const tweaksEncoded = encodeURI(JSON.stringify(tweaks));
  const draftEncoded = encodeURI(JSON.stringify(draft));

  src += `?_s=${qs}&_m=embedded&_t=${tweaksEncoded}&_d=${draftEncoded}`;

  return (
    <iframe
      className="border border-b-primary bg-background"
      src={src}
      title="Book your trip"
      width="100%"
      height="100%"
    ></iframe>
  );
}
